export const YEARLINGS_BOBTAIL_WEBSITE = 'https://www.yearlingsbobtail.com/'
export const MAILING_LIST_WEBSITE = 'https://bobtail.substack.com'
